import React from 'react';
import { StyleSheet } from 'react-native';

import PlayIcon from '@/assets/icons/play';
import { Text } from '@/components/TextComponent';
import { AppColors } from '@/components/lib/theme';

import { Box, Row } from './lib/components';
import { ds } from './lib/design.system';

const TAG_OUTSIDE_HEIGHT_SMALL = 6;
export const TAG_OUTSIDE_HEIGHT_LARGE = 10;

export const LiveTag = ({ size }: { size: 'small' | 'large' }) => {
    return <Tag label={'Live'} color={ds.colorToken.background.danger.strong} size={size} Icon={<PlayIcon />} />;
};

const Tag = ({
    Icon,
    size,
    color,
    label,
}: {
    Icon?: React.JSX.Element;
    size: 'small' | 'large';
    color: AppColors;
    label?: string;
}) => {
    const tagStyle = size === 'small' ? styles.tagSmall : styles.tagLarge;
    return (
        <Row
            backgroundColor={color}
            style={[tagStyle, styles.tag]}
            justifyContent={'center'}
            alignItems={'center'}
            position={'absolute'}
        >
            <Box width={10} height={10}>
                {Icon}
            </Box>
            {size === 'large' ? (
                <Text marginLeft={'s2'} variant="labelMedium" color={'neutral900'}>
                    {label}
                </Text>
            ) : null}
        </Row>
    );
};

const styles = StyleSheet.create({
    tagSmall: { padding: 3, borderRadius: 5, top: -TAG_OUTSIDE_HEIGHT_SMALL },
    tagLarge: { paddingHorizontal: 6, paddingVertical: 2, borderRadius: 6, top: -TAG_OUTSIDE_HEIGHT_LARGE },
    tag: {
        zIndex: 10,
    },
});
